import React from 'react'
import { Navigate } from 'react-router-dom'

const QualityAssuranceListPageWrapper = () => {
  return <Navigate to={'/quality-assurance/list'}/>
}

export default QualityAssuranceListPageWrapper